import React from 'react';
import PropTypes from 'prop-types';
import { CheckCircleFilled, ExclamationCircleFilled } from '@ant-design/icons';
import classNames from 'classnames';
import { sectionPropertyState } from '~constants/listing-management';

export default class NavigationOption extends React.Component {
  render() {
    const { text, sectionState, isSelected, isPublished, addonTag } = this.props;
    return (
      <li
        className={classNames('navigation-bar__option', {
          'navigation-bar__option--selected': isSelected,
        })}
        role="presentation"
        onClick={this.props.handleSelectOption}
      >
        <span>{text}</span>
        <If condition={isPublished}>{addonTag}</If>
        <If condition={!isPublished}>
          <Choose>
            <When condition={sectionState === sectionPropertyState.FILLED}>
              <CheckCircleFilled
                style={{
                  width: '16px',
                  height: '16px',
                  color: '#38b2a6',
                }}
              />
            </When>
            <When condition={sectionState === sectionPropertyState.NOT_FILLED}>
              <CheckCircleFilled
                style={{
                  width: '16px',
                  height: '16px',
                  color: '#c8c9cb',
                }}
              />
            </When>
            <When condition={sectionState === sectionPropertyState.NOT_SUFFICIENT}>
              <ExclamationCircleFilled
                style={{
                  width: '16px',
                  height: '16px',
                  color: '#faad14',
                }}
              />
            </When>
          </Choose>
        </If>
      </li>
    );
  }
}

NavigationOption.propTypes = {
  sectionState: PropTypes.string,
  text: PropTypes.string,
  isSelected: PropTypes.bool,
  handleSelectOption: PropTypes.func,
  isPublished: PropTypes.bool,
  addonTag: PropTypes.node,
};

NavigationOption.defaultProps = {
  sectionState: '',
  text: '',
  isSelected: false,
  handleSelectOption: () => {},
  isPublished: false,
  addonTag: null,
};
